import _classCallCheck from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import { Observable } from "observable-fns";

var doNothing = function doNothing() {
  return undefined;
};

var returnInput = function returnInput(input) {
  return input;
};

var runDeferred = function runDeferred(fn) {
  return Promise.resolve().then(fn);
};

function fail(error) {
  throw error;
}

function isThenable(thing) {
  return thing && typeof thing.then === "function";
}
/**
 * Creates a hybrid, combining the APIs of an Observable and a Promise.
 *
 * It is used to proxy async process states when we are initially not sure
 * if that async process will yield values once (-> Promise) or multiple
 * times (-> Observable).
 *
 * Note that the observable promise inherits some of the observable's characteristics:
 * The `init` function will be called *once for every time anyone subscribes to it*.
 *
 * If this is undesired, derive a hot observable from it using `makeHot()` and
 * subscribe to that.
 */


export var ObservablePromise =
/*#__PURE__*/
function (_Observable) {
  _inherits(ObservablePromise, _Observable);

  function ObservablePromise(init) {
    var _this;

    _classCallCheck(this, ObservablePromise);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ObservablePromise).call(this, function (originalObserver) {
      // tslint:disable-next-line no-this-assignment
      var self = _assertThisInitialized(_assertThisInitialized(_this));

      var observer = Object.assign(Object.assign({}, originalObserver), {
        complete: function complete() {
          originalObserver.complete();
          self.onCompletion();
        },
        error: function error(_error) {
          originalObserver.error(_error);
          self.onError(_error);
        },
        next: function next(value) {
          originalObserver.next(value);
          self.onNext(value);
        }
      });

      try {
        _this.initHasRun = true;
        return init(observer);
      } catch (error) {
        observer.error(error);
      }
    }));
    _this.initHasRun = false;
    _this.fulfillmentCallbacks = [];
    _this.rejectionCallbacks = [];
    _this.firstValueSet = false;
    _this.state = "pending";
    return _this;
  }

  _createClass(ObservablePromise, [{
    key: "onNext",
    value: function onNext(value) {
      if (!this.firstValueSet) {
        this.firstValue = value;
        this.firstValueSet = true;
      }
    }
  }, {
    key: "onError",
    value: function onError(error) {
      this.state = "rejected";
      this.rejection = error;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var onRejected = _step.value;
          // Promisifying the call to turn errors into unhandled promise rejections
          // instead of them failing sync and cancelling the iteration
          runDeferred(function () {
            return onRejected(error);
          });
        };

        for (var _iterator = this.rejectionCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "onCompletion",
    value: function onCompletion() {
      var _this2 = this;

      this.state = "fulfilled";
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop2 = function _loop2() {
          var onFulfilled = _step2.value;
          // Promisifying the call to turn errors into unhandled promise rejections
          // instead of them failing sync and cancelling the iteration
          runDeferred(function () {
            return onFulfilled(_this2.firstValue);
          });
        };

        for (var _iterator2 = this.fulfillmentCallbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop2();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "then",
    value: function then(onFulfilledRaw, onRejectedRaw) {
      var _this3 = this;

      var onFulfilled = onFulfilledRaw || returnInput;
      var onRejected = onRejectedRaw || fail;
      var onRejectedCalled = false;
      return new Promise(function (resolve, reject) {
        var rejectionCallback = function rejectionCallback(error) {
          if (onRejectedCalled) return;
          onRejectedCalled = true;

          try {
            resolve(onRejected(error));
          } catch (anotherError) {
            reject(anotherError);
          }
        };

        var fulfillmentCallback = function fulfillmentCallback(value) {
          try {
            resolve(onFulfilled(value));
          } catch (error) {
            rejectionCallback(error);
          }
        };

        if (!_this3.initHasRun) {
          _this3.subscribe({
            error: rejectionCallback
          });
        }

        if (_this3.state === "fulfilled") {
          return resolve(onFulfilled(_this3.firstValue));
        }

        if (_this3.state === "rejected") {
          onRejectedCalled = true;
          return resolve(onRejected(_this3.rejection));
        }

        _this3.fulfillmentCallbacks.push(fulfillmentCallback);

        _this3.rejectionCallbacks.push(rejectionCallback);
      });
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onCompleted) {
      var handler = onCompleted || doNothing;
      return this.then(function (value) {
        handler();
        return value;
      }, function () {
        return handler();
      });
    }
  }], [{
    key: "from",
    value: function from(thing) {
      if (isThenable(thing)) {
        return new ObservablePromise(function (observer) {
          var onFulfilled = function onFulfilled(value) {
            observer.next(value);
            observer.complete();
          };

          var onRejected = function onRejected(error) {
            observer.error(error);
          };

          thing.then(onFulfilled, onRejected);
        });
      } else {
        return _get(_getPrototypeOf(ObservablePromise), "from", this).call(this, thing);
      }
    }
  }]);

  return ObservablePromise;
}(Observable);